(function($){

  // make sure image gets filled to container when switching tabs
  function setTabImageSizes() {

    $('.component--tabs a[role="tab"]').on('shown.bs.tab', function (e) {
      let $tabContentTarget = $(e.target.value);

      // check to see if tabs have an img that needs to fill its container
      let tabContentMedia = $tabContentTarget.find('.js-fill-media-to-container');

      if (tabContentMedia) {
        window.loomisHelpers.fillMediaToContainer();
      }
    })
  }

  setTabImageSizes();

  // MOBILE ONLY: Link bootstrap select 'option' values to matching tab
  function setMobileTabDropdowns() {

    $('.selectpicker--tab-dropdowns').on('changed.bs.select', function (e, clickedIndex, isSelected, previousValue) {

      let $tabTarget = $(e.target.value + '-tab');
      let $tabContentTarget = $(e.target.value);

      $tabTarget.addClass('active').siblings().removeClass('active');

      $tabContentTarget.tab('show');
      $tabContentTarget.siblings().removeClass('active show');

    });
  }

  setMobileTabDropdowns();


})(jQuery);


